import { Stack, Box, Typography, Divider, Button } from "@mui/material";
import FormField from "../form-field/form-field.component";
import PassengerForm from "../passenger-form/passenger-form.component";
import EmergencyContactForm from "../emergency-contact-form/emergency-contact-form.component";
import LinkButton from "../link-button/link-button.component";
import BillingForm from "../billing-form/billing-form.component";
import PaymentMethodSelector from "../payment-method-selector/payment-method-selector.component";
import CreditCardForm from "../credit-card-form/credit-card-form.component";
import BasicInsuranceOffer from "../basic-insurance-offer/basic-insurance-offer.component";
import PurchaseDetails from "../purchase-details/purchase-details.component";

export const FragmentComponent = ({
  activeStep,
  handleNext,

  passengers,
  handlePassengerChange,
  handlePassengerBirthDateChange,
  handleRemovePassengerClick,
  handleAddPassengerClick,
  emergencyContact,
  emergencyContactErrors,
  handleEmergencyContactFormChange,
  handleCopyPassengerInfoClick,
  billingInfo,
  billingErrors,
  handleBillingFormChange,
  paymentMethod,
  handlePaymentMethodSelection,
  isCreditCard,
  total,
  creditCardInfo,
  creditCardFormErrors,
  handleCreditCardFormChange,
  selectedInsurance,
  destination,
  boardingDate,
  arrivalDate,
  youngPassengers,
  oldPassengers,
  passengerPrice,
  oldPassengerPrice,
  subtotal,
  discount,
  handleDiscountCupomChange,
  discountCupom,
  discountCupomError,
  validatePassengers,
  validateBilling,
  setBillingErrors,
  setPassengers,
  setEmergencyContactErrors,
}) => {
  const handleSteps = () => {
    if (activeStep === 0) {
      // Check if all required passenger fields are filled
      let hasErrors = false;

      // Create a copy of passengers to add errors
      const updatedPassengers = [...passengers];

      updatedPassengers.forEach((passenger, index) => {
        const { fullName, cpf, birthDate, email, phone, gender } = passenger;
        const errors = {};

        if (!fullName) {
          errors.fullName = "Campo obrigatório";
          hasErrors = true;
        }

        if (!cpf) {
          errors.cpf = "Campo obrigatório";
          hasErrors = true;
        }

        if (!birthDate) {
          errors.birthDate = "Campo obrigatório";
          hasErrors = true;
        }

        if (!email) {
          errors.email = "Campo obrigatório";
          hasErrors = true;
        }

        if (!phone) {
          errors.phone = "Campo obrigatório";
          hasErrors = true;
        }

        if (!gender) {
          errors.gender = "Campo obrigatório";
          hasErrors = true;
        }

        if (Object.keys(errors).length > 0) {
          updatedPassengers[index] = { ...passenger, errors };
        }
      });

      // Check emergency contact
      const emergencyErrors = {};
      if (!emergencyContact.fullName) {
        emergencyErrors.fullName = "Campo obrigatório";
        hasErrors = true;
      }

      if (!emergencyContact.phone) {
        emergencyErrors.phone = "Campo obrigatório";
        hasErrors = true;
      }

      // Update state with errors
      if (hasErrors) {
        setPassengers(updatedPassengers);
        setEmergencyContactErrors(emergencyErrors);
        window.scrollTo(0, 0);
        return;
      }

      // If all required fields are filled, proceed with validation
      const isValid = validatePassengers();

      if (isValid) {
        handleNext();
      } else {
        window.scrollTo(0, 0);
      }
    } else if (activeStep === 1) {
      // Similar approach for billing info
      const errors = {};
      let hasErrors = false;

      if (!billingInfo.fullName) {
        errors.fullName = "Campo obrigatório";
        hasErrors = true;
      }

      if (!billingInfo.cpf) {
        errors.cpf = "Campo obrigatório";
        hasErrors = true;
      }

      if (!billingInfo.email) {
        errors.email = "Campo obrigatório";
        hasErrors = true;
      }

      if (!billingInfo.phone) {
        errors.phone = "Campo obrigatório";
        hasErrors = true;
      }

      if (hasErrors) {
        setBillingErrors(errors);
        window.scrollTo(0, 0);
        return;
      }

      // If all required fields are filled, proceed with validation
      const isValid = validateBilling();

      if (isValid) {
        handleNext();
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      // For the final step
      handleNext();
    }
  };

  switch (activeStep) {
    case 0:
      return (
        <Stack>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "1.5rem",
            }}
          >
            <Typography
              variant="h4"
              sx={{ color: "primary.main", fontWeight: "bolder" }}
            >
              Identificação dos Segurados
            </Typography>
          </Box>

          <Stack direction={"column"} sx={{ margin: "1rem 0", width: "100%" }}>
            {passengers.map((passenger, idx) => (
              <div key={idx}>
                <PassengerForm
                  id={idx}
                  passenger={passenger}
                  onChange={handlePassengerChange}
                  onRemove={handleRemovePassengerClick}
                  onBirthDateChange={handlePassengerBirthDateChange}
                />
                <Divider
                  sx={{
                    borderColor: "primary.main",
                    margin: "1rem 0",
                  }}
                />
              </div>
            ))}

            <Button
              variant="contained"
              onClick={handleAddPassengerClick}
              sx={{
                borderRadius: "4px",
                py: 1.5,
                textTransform: "none",
              }}
            >
              <Typography variant="body1">
                Adicionar mais passageiros +
              </Typography>
            </Button>
          </Stack>
          <Typography variant="h3" sx={{ mb: "1rem" }}>
            Dados do contato de emergência
          </Typography>

          <EmergencyContactForm
            emergencyContact={emergencyContact}
            errors={emergencyContactErrors}
            onChange={handleEmergencyContactFormChange}
          />
          <Divider
            sx={{
              borderColor: "primary.main",
              margin: "1rem 0",
            }}
          />

          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "secondary.main",
              borderRadius: "4px",
              py: 1.5,
              fontSize: "1.5rem",
              color: "black",
              fontWeight: "bolder",
              width: "100%",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            }}
            onClick={handleSteps}
          >
            Próxima etapa
          </Button>
        </Stack>
      );
    case 1:
      return (
        <Stack>
          <Box sx={{ marginBottom: "1rem" }}>
            <Typography variant="h3" sx={{ color: "primary.main" }}>
              Dados para receber os vouchers
            </Typography>

            <LinkButton
              onClick={handleCopyPassengerInfoClick}
              sx={{ color: "black", mb: "0.5rem" }}
            >
              Utilizar dados do 1° segurado
            </LinkButton>
          </Box>
          <BillingForm
            billingInfo={billingInfo}
            errors={billingErrors}
            onChange={handleBillingFormChange}
          />
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: "secondary.main",
              borderRadius: "4px",
              py: 1.5,
              mt: "1rem",
              fontSize: "1.5rem",
              color: "black",
              fontWeight: "bolder",
              width: "100%",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            }}
            onClick={handleSteps}
          >
            Próxima etapa
          </Button>
        </Stack>
      );
    default:
      return (
        <Stack>
          <Typography variant="h3" sx={{ color: "primary.main" }}>
            Forma de pagamento
          </Typography>

          <PaymentMethodSelector
            selected={paymentMethod}
            onSelect={handlePaymentMethodSelection}
          />
          {isCreditCard && (
            <CreditCardForm
              value={total}
              creditCardInfo={creditCardInfo}
              errors={creditCardFormErrors}
              onChange={handleCreditCardFormChange}
              insuranceCompany={selectedInsurance.insuranceCompany}
            />
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2rem",
              width: "fit-content",
              minWidth: { xs: "100%", md: "380px" },
              mt: "1rem",
            }}
          >
            <BasicInsuranceOffer
              insurance={selectedInsurance}
              destination={destination}
              boardingDate={boardingDate}
              arrivalDate={arrivalDate}
            />
            <PurchaseDetails
              youngPassengers={youngPassengers}
              oldPassengers={oldPassengers}
              passengerPrice={passengerPrice}
              oldPassengerPrice={oldPassengerPrice}
              subtotal={subtotal}
              discount={discount}
              total={total}
            />

            {/* Campo de cupom escondido até existir uma campanha de cupom
                real (a validação ainda não foi implementada). */}
            {/* <FormField
              label="Cupom"
              name="discountCupom"
              variant="light"
              onChange={handleDiscountCupomChange}
              value={discountCupom}
              error={discountCupomError}
            /> */}
            <Button
              type="submit"
              variant="contained"
              sx={{
                textTransform: "none",
                backgroundColor: "secondary.main",
                borderRadius: "4px",
                py: 1.5,
                mt: "1rem",
                fontSize: "1.5rem",
                color: "black",
                fontWeight: "bolder",
                width: "100%",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              }}
            >
              <Typography variant="body1">Finalizar pedido</Typography>
            </Button>
            <Typography variant="body2">
              Ao clicar em Finalizar pedido, concordo que li e aceito os&nbsp;
              <a
                className="terms-link"
                href="https://drive.google.com/file/d/1U3CE3VDg1-7lMKkdTSVyjQepqD23hYOK/view"
                target="_blank"
                rel="noreferrer"
              >
                termos de uso, condições gerais e coberturas
              </a>
            </Typography>
          </Box>
        </Stack>
      );
  }
};
